// appVersionCheck.js
import SecureLS from 'secure-ls';
var ls = new SecureLS({ encodingType: 'aes' });

const APP_VERSION = '1.1.0'; // Ovde stavite trenutnu verziju aplikacije ukoliko je potrebno da se obrise localStorage sa klijentskih masina
if (typeof (Storage) !== "undefined") {
    const storedVersion = localStorage.getItem('appVersion') ? localStorage.getItem('appVersion') : '';

    if (APP_VERSION !== storedVersion) {
        localStorage.clear();
        ls.clear();
        localStorage.setItem('appVersion', APP_VERSION);
        window.location.reload();
    } else {
        // todo: mozda je potrebno da se doda jos nesto ovde, ali zasad ne treba
    }
} else {
    console.warn('Local storage is not supported by this browser.');
}